"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { Bot, CreditCard, LayoutDashboard, Key } from "lucide-react";
import { cn } from "@/lib/utils";

const GLOBAL_NAV_ITEMS = [
  {
    title: "Overview",
    href: "/dashboard",
    icon: LayoutDashboard,
  },
  {
    title: "Bots",
    href: "/dashboard/bots",
    icon: Bot,
  },
  {
    title: "Billing",
    href: "/dashboard/billing",
    icon: CreditCard,
  },
  {
    title: "API Keys",
    href: "/dashboard/api-keys",
    icon: Key,
  },
];

export function Sidebar() {
  const pathname = usePathname();

  // Determine if we are in a bot-specific context
  // e.g. /dashboard/bots/[botId]/...
  const isBotContext = pathname.startsWith("/dashboard/bots/") && pathname.split("/").length > 3;

  // We will pass the bot nav items via a wrapper in [botId]/layout.tsx later.
  // For now, this global sidebar will hide its links if we are inside a bot context,
  // or it could show the global links. Let's show global links always for the shell, 
  // but highlight appropriately.

  return (
    <div className="hidden border-r bg-muted/40 md:block w-64 flex-shrink-0">
      <div className="flex h-full max-h-screen flex-col gap-2">
        <div className="flex h-14 items-center border-b px-4 lg:h-[60px] lg:px-6">
          <Link href="/" className="flex items-center gap-2 font-semibold">
            <Bot className="h-6 w-6" />
            <span className="">AnyBot SaaS</span>
          </Link>
        </div>
        <div className="flex-1 overflow-auto py-2">
          <nav className="grid items-start px-2 text-sm font-medium lg:px-4 gap-1">
            {GLOBAL_NAV_ITEMS.map((item) => {
              const isActive = pathname === item.href || (item.href !== "/dashboard" && pathname.startsWith(item.href) && !isBotContext);
              return (
                <Link
                  key={item.href}
                  href={item.href}
                  className={cn(
                    "flex items-center gap-3 rounded-lg px-3 py-2 transition-all hover:bg-accent hover:text-accent-foreground",
                    isActive ? "bg-accent/50 text-primary" : "text-muted-foreground"
                  )}
                >
                  <item.icon className="h-4 w-4" />
                  {item.title}
                </Link>
              );
            })}
          </nav>
        </div>
      </div>
    </div>
  );
}
